import { useEffect, useRef, useState } from "react";

// Swagger UI rendered from the engine's embedded spec (proxied via the BFF).
// swagger-ui-dist is framework-agnostic (no React peer dep) and is loaded
// lazily so the main bundle stays slim.
export function ApiSpecView({
  specPath = "/api/portal/noti/openapi.yaml",
  title = "API Spec",
  note,
}: {
  specPath?: string;
  title?: string;
  note?: string;
}) {
  const host = useRef<HTMLDivElement>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    Promise.all([
      import("swagger-ui-dist/swagger-ui-bundle.js"),
      import("swagger-ui-dist/swagger-ui.css"),
    ])
      .then(([mod]) => {
        if (!alive || !host.current) return;
        const SwaggerUIBundle = mod.default;
        SwaggerUIBundle({
          url: specPath,
          domNode: host.current,
          deepLinking: false,
          docExpansion: "list",
          defaultModelsExpandDepth: 0,
          tryItOutEnabled: true,
          supportedSubmitMethods: ["get", "post", "put", "patch", "delete"],
          // Execute fires same-origin to the spec's first server
          // (https://notification.blockfint.com → engine via Caddy), so
          // teams can test from the docs. Auth via the Authorize button
          // (X-Client-Id + X-Client-Secret); remember it across reloads.
          persistAuthorization: true,
        });
      })
      .catch(
        (e) => alive && setErr(e instanceof Error ? e.message : String(e)),
      );
    return () => {
      alive = false;
    };
  }, [specPath]);

  return (
    <div className="panel">
      <h3>{title}</h3>
      <p
        className="muted"
        style={{ margin: "0 0 0.6rem", fontSize: "0.85rem" }}
      >
        {note ?? "สเปคตัวจริง embed อยู่ในตัว service"} — ดาวน์โหลดไฟล์ดิบ:{" "}
        <a href={specPath} target="_blank" rel="noreferrer">
          {specPath.split("/").pop()}
        </a>
      </p>
      {err && <div className="error">โหลด Swagger UI ไม่สำเร็จ: {err}</div>}
      <div ref={host} className="swagger-host" />
    </div>
  );
}
